import React from 'react';

const Footer: React.FC = () => {
  return (
    <footer className="bg-navy-light border-t border-white">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-6 md:py-12">
        {/* Mobile: Centered Layout */}
        <div className="block md:hidden text-center">
          <div className="mb-4">
            <h3 className="text-xl font-semibold text-white mb-2">Inner Wealth Coaching</h3>
            <p className="text-blue leading-relaxed mb-4">
              Private coaching for those who already have enough — yet don't feel it.
            </p>
          </div>

          <div className="mb-4">
            <h3 className="text-lg font-semibold text-white mb-2">Contact</h3>
            <div className="space-y-1 text-white mb-4">
              <p>
                <a href="mailto:info@innerwealthcoaching.com" style={{ color: 'inherit', textDecoration: 'none' }}>
                  info@innerwealthcoaching.com
                </a>
              </p>
              <p>
                <a href="tel:+442035751474" style={{ color: 'inherit', textDecoration: 'none' }}>
                  +44 (0)20 3575 1474
                </a>
              </p>
            </div>
            <div className="text-center mb-4">
              <div className="inline-flex space-x-6 text-sm">
                <a href="#terms" className="text-blue hover:text-white transition-colors">
                  Terms of Service
                </a>
                <a href="#privacy" className="text-blue hover:text-white transition-colors">
                  Privacy Policy
                </a>
                <a href="#gdpr" className="text-blue hover:text-white transition-colors">
                  GDPR
                </a>
              </div>
            </div>
          </div>

          <p className="text-white text-sm">
            Created by <a href="https://wavelynecode.com" target="_blank" rel="noopener noreferrer" className="hover:text-blue transition-colors">Wavelyne</a>
          </p>
        </div>

        {/* Desktop: 2-Column Layout */}
        <div className="hidden md:block">
          <div className="max-w-5xl mx-auto flex justify-between">
          {/* Left Section - Brand */}
          <div>
            <h3 className="text-xl font-light text-white mb-4">Inner Wealth Coaching</h3>
            <p className="text-blue leading-relaxed mb-6">
              Private coaching for those who <br />already have enough —
              yet don't feel it.
            </p>
            <p className="text-white text-sm">
              Created by <a href="https://wavelynecode.com" target="_blank" rel="noopener noreferrer" className="hover:text-blue transition-colors">Wavelyne</a>
            </p>
          </div>

          {/* Right Section - Contact */}
          <div>
            <h3 className="text-lg font-medium text-white mb-4">Contact</h3>
            <div className="space-y-2 text-white mb-6">
              <p>
                <a href="mailto:info@innerwealthcoaching.com" style={{ color: 'inherit', textDecoration: 'none' }}>
                  info@innerwealthcoaching.com
                </a>
              </p>
              <p>
                <a href="tel:+442035751474" style={{ color: 'inherit', textDecoration: 'none' }}>
                  +44 (0)20 3575 1474
                </a>
              </p>
            </div>
            <div className="flex space-x-6 text-sm">
              <a href="#terms" className="text-blue hover:text-white transition-colors">
                Terms of Service
              </a>
              <a href="#privacy" className="text-blue hover:text-white transition-colors">
                Privacy Policy
              </a>
              <a href="#gdpr" className="text-blue hover:text-white transition-colors">
                GDPR
              </a>
            </div>
          </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
